import { render, staticRenderFns } from "./AcademicAllCourses.html?vue&type=template&id=1c8f82d0&scoped=true&"
import script from "./AcademicAllCourses.vue?vue&type=script&lang=js&"
export * from "./AcademicAllCourses.vue?vue&type=script&lang=js&"
import style0 from "./AcademicAllCourses.scss?vue&type=style&index=0&id=1c8f82d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8f82d0",
  null
  
)

export default component.exports